import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  withStyles,
} from '@material-ui/core'
import {
  Add as AddIcon,
} from '@material-ui/icons'

import { LIST_TYPE, ROUTES } from '../constant'
import { navigate } from '../actions/app'
import { getMarkets } from '../actions/market'
import Button from '../components/Button'
import Breadcrumb from '../components/Breadcrumb'
import ListAutomation from '../components/ListAutomation'


const styles = theme => ({
  root: {
    paddingTop: 0,
    padding: theme.spacing(1),
  },
})


class ListMarkets extends Component {
  /* LIFECYCLE */


  /* METHODS */

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  handleItemClick = (item) => {
    this.props.history.push(`${ROUTES.MARKET}/${item.id}`)
  }

  handleNavigateAddMarket = () => {
    this.props.navigate(`${ROUTES.MARKET}/add`)
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      items,
      classes,
      hasMore,
      isLoading,
      endBefore,
      startAfter,
      hasPrevious,
    } = this.props

    return (
      <div className={classes.root}>
        <Breadcrumb
          data={[
            { label: 'Accueil', to: '/' },
            'Commerces',
          ]}
          actions={(
            <Link
              color="primary"
              component={Button}
              to={`${ROUTES.MARKET}/add`}
            >
              <AddIcon /> Créer{' '}
            </Link>
          )}
        />

        <ListAutomation
          items={items}
          isLoading={isLoading}
          hasMore={hasMore}
          endBefore={endBefore}
          startAfter={startAfter}
          hasPrevious={hasPrevious}
          title="Liste des commerces"
          onClick={this.handleItemClick}
          request={this.props.getMarkets}
          head={['Nom', 'Date de création']}
          row={item => ({
            primary: item.name,
            secondary: item.disabled ? 'Désactivé' : '',
            data: [item.name, moment(item.created_at).format('DD/MM/YYYY')],
          })}
        />

        <Button
          margin
          fullWidth
          color="primary"
          component={Button}
          onClick={this.handleNavigateAddMarket}
        >
          <AddIcon /> Créer{' '}
        </Button>
      </div>
    )
  }
}


ListMarkets.propTypes = {
  hasMore: PropTypes.bool,
  hasPrevious: PropTypes.bool,
  endBefore: PropTypes.string,
  startAfter: PropTypes.string,
  navigate: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  getMarkets: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
}


const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  endBefore: state.list.endBefore,
  startAfter: state.list.startAfter,
  items: state.list.type === LIST_TYPE.MARKETS ? state.list.items : [],
  hasMore: state.list.type === LIST_TYPE.MARKETS ? state.list.hasMore : false,
  hasPrevious: state.list.type === LIST_TYPE.MARKETS ? state.list.hasPrevious : false,
})


export default connect(mapStateToProps, {
  navigate,
  getMarkets,
})(withStyles(styles)(ListMarkets))
